import context from '@/main.js'

const types = {
  403: {
    title: '403',
    btnName: context.$i18n.t('disp.returnToLogin'),
    desc: context.$i18n.t('msg.noAuth')
  },
  404: {
    title: '404',
    btnName: context.$i18n.t('disp.returnToPortal'),
    desc: context.$i18n.t('disp.noPage')
  },
  500: {
    title: '500',
    btnName: context.$i18n.t('disp.returnToPortal'),
    desc: context.$i18n.t('msg.error500')
  }
}

export default types